module.exports = __webpack_public_path__ + "static/media/sell_send_money_6.7bd49f31.jpg";